import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../components/layout";

const query = graphql`
  query SiteTitleQuery {
    site: sanitySiteSettings(_id: { regex: "/(drafts.|)siteSettings/" }) {
      title
    }
    footer: allSanityFooter {
      edges {
        node {
          id
          formSection
          buttonText
          inputPlaceholder
          sectionText
          footerSection
          noteText
          firstTab
          firstTabTitle
          firstTabItems {
            itemTitle
            itemURL
            _key
          }
          secondTab
          secondTabTitle
          secondTabItems {
            itemTitle
            itemURL
            _key
          }
        }
      }
    }
    header: allSanityHeader {
      edges {
        node {
          headerSection
          headerTab
          headerTabItems {
            itemTitle
            itemURL
            _key
          }
          buttonTab
          buttonText
        }
      }
    }
  }
`;

function LayoutContainer(props) {
  const [showNav, setShowNav] = useState(false);

  function handleShowNav() {
    setShowNav(true);
  }

  function handleHideNav() {
    setShowNav(false);
  }

  const data = useStaticQuery(query);
  if (!data.site) {
    throw new Error(
      'Missing "Site settings". Open the Studio at http://localhost:3333 and some content in "Site settings"'
    );
  }

  const footerData = (data || {}).footer;
  const headerData = (data || {}).header;

  return (
    <Layout
      {...props}
      showNav={showNav}
      siteTitle={data.site.title}
      onHideNav={handleHideNav}
      onShowNav={handleShowNav}
      footerData={footerData.edges}
      headerData={headerData.edges}
    />
  );
}

export default LayoutContainer;
